import { Button, Flex, FormControl, Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import Checkbox from 'react-custom-checkbox';
import { educationLevelOptions } from 'utils';

const educationDefaults = Object.fromEntries(
  educationLevelOptions.map(({ key }) => [key, false]),
);

const EducationLevel = ({ prev }: { prev: () => void }): JSX.Element => {
  const {
    values: { educationLevel },
    setFieldValue,
    handleSubmit,
    isValid,
    isSubmitting,
  } = useFormikContext<ApplicationQuestionsValues>();

  return (
    <Flex direction="column" width="100%">
      <Flex direction="column" bg="custom.levoAlabaster" py="61.5px" px={6}>
        <Text textStyle="heading3" fontWeight="bold">
          What is your education level?
        </Text>
        <FormControl
          id="educationLevel"
          display="flex"
          flexDirection="column"
          mt={6}
        >
          {educationLevelOptions.map(({ id, key, value }) => (
            <Flex
              key={`education-level-${id}`}
              direction="row"
              _notLast={{
                mb: 4,
              }}
            >
              <Checkbox
                checked={!!educationLevel[key]}
                borderColor="#E1DDDD"
                borderRadius="50%"
                icon={<Flex flex={1} alignItems="center" />}
                style={{
                  overflow: 'hidden',
                  border: '2px solid #E1DDDD',
                  backgroundColor: !!educationLevel[key] ? '#259BE9' : 'white',
                }}
                size={24}
                onChange={(val: boolean) => {
                  const newLevels = { ...educationDefaults, [key]: val };
                  setFieldValue('educationLevel', newLevels);
                }}
              />
              <Text ml={4}>{value}</Text>
            </Flex>
          ))}
        </FormControl>
      </Flex>
      <Flex width="100%" justifyContent="space-between" mt={6}>
        <Button
          width="fit-content"
          height="fit-content"
          bg="custom.levoDarkSnow"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          isDisabled={isSubmitting}
          onClick={prev}
        >
          <Text textStyle="body" fontWeight={700} color="custom.levoBlue">
            Back
          </Text>
        </Button>
        <Button
          width="fit-content"
          height="fit-content"
          bg="custom.levoBlue"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          isDisabled={!educationLevel || !isValid || isSubmitting}
          isLoading={isSubmitting}
          onClick={() => handleSubmit()}
        >
          <Text textStyle="body" fontWeight={700} color="white">
            Next
          </Text>
        </Button>
      </Flex>
    </Flex>
  );
};

export default EducationLevel;
